const serialize = (item: string): string => item;
const deserialize = (str: string): string => str;

export default { deserialize, serialize };